module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAZCAYAAADAHFVeAAABDklEQVRIie2WsU4CQRBA35E7kwsFJLb+gRUFnS21fAIVofcHaPwASkJrZ0NBa2X4BQsT/wCChYmi4JhJFthsbl0tbsXkJplkZ2Z33s5kM9lEROpARvmyVtgUuIwAG9UiQPZSwSrY0cByha0iwV4UNo8Em+sEyYFH4KxEkOY/18pegetvNn4CY+DDE9fzkwBsCGx2D+TNCmwtyB1wAQyANjDTQyb+DtwCLaAPdIB7QDwXAhFR7clBuiJyKiKZiammxlezfLaemLjtu3JyknrKXjq2VrMItCpx7K27wQf7TdKithVKNRv/H6zogegHqOn4Gtbajdn+Z8vOfwK7CVzQN7iDA/1P2vigX60SOU8AX+sqhRUsWO/nAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/baiicon/icon_sd.png
// module id = ELzR
// module chunks = 10